<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>

    <Header />
    <b-container fluid="">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span>ETL</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>DX_</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">
          <p>Administración de caracteres</p>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <br />
          <h3>Búsqueda de caracteres</h3>
          <br />
        </b-col>
      </b-row>
       <b-row>
         <b-col>
      <b-form-group id="input-group-1" label="Sistema:">
              <v-select
                style="width: 100%"
                label="descripcion"
                :options="listaCanales"
                :reduce="(canal) => canal.idCanalOrigen"
                v-model="canal"
                placeholder=""
                required="true"
                @input="obtenerSistemaSeleccionado()"
              >
                <template slot="no-options">Sin datos</template>
              </v-select>
            </b-form-group>
            </b-col>
            <b-col></b-col>
            <b-col></b-col>
       </b-row>
      <b-form v-on:submit.prevent="buscarCaracteres()">
        <b-row>
          <b-col cols="4">
            <b-form-group id="input-group-1" label="Empresa:">
              <v-select
                style="width: 100%"
                label="nombre"
                :options="empresas"
                :reduce="(empresa) => empresa.id"
                v-model="idEmpresa"
                placeholder=""
                required="true"
                v-bind:class="{ disabled: canal !== 27 }"
              >
                <template slot="no-options">Sin datos</template>
              </v-select>
            </b-form-group>

            <br />

            <b-form-group id="input-group-1" label="Pestaña:">
              <v-select
                style="width: 100%"
                label="nombre"
                :options="
                  pestaniaArray.filter((pes) => pes.idEmpresa == this.idEmpresa)
                "
                :reduce="(pesta) => pesta.nombre"
                v-model="pestania"
                placeholder=""
                 v-bind:class="{ disabled: canal !== 27 }"
              >
                <template slot="no-options">Sin datos</template>
              </v-select>
            </b-form-group>
          </b-col>

          <b-col cols="4">
            <b-form-group id="input-group-1" label="Columna:">
              <v-select
                style="width: 100%"
                label="nombre"
                :options="columnas"
                :reduce="(columna) => columna.nombre"
                v-model="columnaNombre"
                placeholder=""
              >
                <template slot="no-options">Sin datos</template>
              </v-select>
            </b-form-group>
          </b-col>

          <b-col cols="4"
            ><br />
            <b-button
              type="submit"
              class="btn-block"
              variant="success"
              v-if="canal"
              >Buscar</b-button
            >
            <b-alert v-else show variant="danger"
              >Selecciona un sistema</b-alert
            >
          </b-col>
        </b-row>
      </b-form>

      <b-row>
        <b-col cols="12"
          ><hr />
          <h3 v-if="modificarFormulario">Modificar caracter</h3>
          <h3 v-else>Agregar nuevo caracter</h3>
        </b-col>
      </b-row>
        <b-row>
         <b-col>
      <b-form-group id="input-group-1" label="Sistema:">
              <v-select
                style="width: 100%"
                label="descripcion"
                :options="listaCanales"
                :reduce="(canal) => canal.idCanalOrigen"
                v-model="form.canal"
                placeholder=""
                required="true"
                 @input="obtenerSistemaSeleccionado()"
              >
                <template slot="no-options">Sin datos</template>
              </v-select>
            </b-form-group>
            </b-col>
            <b-col></b-col>
            <b-col></b-col>
       </b-row>
      <b-form v-on:submit.prevent="guardarCaracter()">
        <b-row>
          <b-col cols="4">
            <b-form-group id="input-group-1" label="Empresa:">
              <v-select
                style="width: 100%"
                label="nombre"
                :options="empresas"
                :reduce="(empresa) => empresa.id"
                v-model="form.idEmpresa"
                placeholder=""
                required
                v-bind:class="{ disabled: form.canal !== 27 }"
              >
                <template slot="no-options">Sin datos</template>
              </v-select>
            </b-form-group>

            <br />

            <b-form-group id="input-group-1" label="Pestaña:">
              <v-select
                style="width: 100%"
                label="nombre"
                :options="
                  pestaniaArray.filter(
                    (pes) => pes.idEmpresa == this.form.idEmpresa
                  )
                "
                :reduce="(pesta) => pesta.nombre"
                v-model="form.nombrePestania"
                placeholder=""
                required
                v-bind:class="{ disabled: form.canal !== 27 }"
              >
                <template slot="no-options">Sin datos</template>
              </v-select>
            </b-form-group>

            <b-form-group id="input-group-1" label="Columna:">
              <v-select
                style="width: 100%,text-transform: uppercase"
                label="nombre"
                :options="columnas"
                :reduce="(columna) => columna.nombre"
                v-model="form.encabezado"
                placeholder=""
                required
              >
                <template slot="no-options">Sin datos</template>
              </v-select>
            </b-form-group>
          </b-col>

          <b-col cols="4">
            <b-form-group id="input-group-1" label="Caracter:">
              <b-form-input
                id="input-1"
                v-model="form.caracter"
                type="text"
                placeholder="Ingrese el caracter"
                required
                @input="
                  (v) => {
                    form.caracter = v.toUpperCase();
                  }
                "
              ></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-1" label="Reemplazo:">
              <b-form-input
                id="input-1"
                v-model="form.reemplazo"
                type="text"
                placeholder="Ingrese la letra o palabra por reemplazar"
                @input="
                  (v) => {
                    form.reemplazo = v.toUpperCase();
                  }
                "
              ></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-1" label="Orden:">
              <b-form-input
                id="input-1"
                v-model="form.orden"
                type="number"
                placeholder="Ingrese el número del orden"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="4">
            <b-form-group id="input-group-1" label="Estatus:">
              <v-select
                style="width: 100%"
                label="nombre"
                :options="estatus"
                :reduce="(es) => es.boolean"
                v-model="form.registroActivo"
                placeholder=""
                required
              >
                <template slot="no-options">Sin datos</template>
              </v-select>
            </b-form-group>
            <br />

            <b-button
              type="submit"
              class="btn-block"
              variant="success"
              v-if="!modificarFormulario"
            >
              <i class="fa fa-plus" aria-hidden="true"></i> Agregar</b-button
            >

            <b-button type="submit" class="btn-block" variant="success" v-else>
              <i class="fa fa-pencil" aria-hidden="true"></i>
              Modificar</b-button
            >
            <b-button
              type="submit"
              @click="cambiarAGuardar"
              class="btn-block"
              variant="info"
              v-if="modificarFormulario"
            >
              <i class="fa fa-share" aria-hidden="true"></i> Limpiar formulario
              para Agregar caracter</b-button
            >
          </b-col>
        </b-row>
      </b-form>

      <b-row>
        <b-col cols="12"> </b-col>
      </b-row>

      <b-row>
        <b-col cols="12"><hr /></b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <br />
          <h3>Número de Registros: {{ caracteresArrayCantidad }}</h3>
          <br />

          <b-table
            hover
            id="Pendientes"
            thead-tr-class="columnas"
            :items="caracteresArray"
            :fields="layoutTablaCaracteresArray"
            responsive
          >
            <template v-slot:cell(editar)="row">
              <b-button
                type="submit"
                class="btn-block"
                variant="success"
                @click="modificar(row.item.idCaracterReemplazo)"
              >
                <i class="fa fa-pencil" aria-hidden="true"></i> Editar</b-button
              >
            </template>

            <template v-slot:cell(fechaAlta)="row">
              {{ row.item.fechaAlta | formatoFecha }}
            </template>

            <template v-slot:cell(fechaModificacion)="row">
              {{ row.item.fechaModificacion | formatoFecha }}
            </template>

            <template v-slot:cell(registroActivo)="row">
              <b-alert v-if="row.item.registroActivo" show variant="primary"
                >ACTIVO</b-alert
              >
              <b-alert v-else show variant="secondary">INACTIVO</b-alert>
            </template>
          </b-table>
        </b-col>
           <b-col align="center" v-if="loading">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </b-col>
         <b-col v-if="!loading">
            <b-alert v-if="caracteresArrayCantidad === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
      </b-row>

      <b-row>
        <b-col cols="12"> </b-col>
      </b-row>

      <b-row>
        <b-col cols="12"> <br /><br /> </b-col>
      </b-row>

      <!-- </b-col>
      </b-row> -->
      <b-row>
        <b-col cols="12"> <br /><br /> </b-col>
      </b-row>
      <b-row>
        <b-col cols="12"> </b-col>
      </b-row>

      <!-- -------------------------- -->

      <b-row>
        <b-col> <br /><br /><br /><br /><br /><br /> </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from "../../components/Header.vue";

export default {
  name: "etlCaracteres",
  components: {
    Header,
  },
  props: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    loading: false,
    empresas: [
      {
        id: 0,
        nombre: "GENERICO",
      },
      {
        id: 377,
        nombre: "AXA ASSISTANCE",
      },
      {
        id: 143,
        nombre: "AXA SEGUROS",
      },
      {
        id: 291,
        nombre: "GNP",
      },
      {
        id: 470,
        nombre: "INTEGRA SALUD",
      },
      {
        id: 218,
        nombre: "PLAN SEGURO",
      },
      {
        id: 410,
        nombre: "SISNOVA",
      }, 
      {
        id: 407,
        nombre: "MAPFRE",
      },
    ],
    idEmpresa: null,
    //https://dentaliamx-my.sharepoint.com/:x:/g/personal/ieslava_dentalia_com/EQ3dc0anQcRGv95E1ejcgd0B79hV4TQ7Bhjo2H0UNut8gw?e=3cfecM&CID=BBD0042C-5BA6-4B31-BB01-5016EDB6B669&wdLOR=c17DF654D-452C-4D3F-8925-DA236BB47336
    //PALABRA CLAVE-NOMBRE  PESTAÑA
    pestaniaArray: [
      {
        idEmpresa: 0,
        nombre: "GENERICO",
      },
      {
        idEmpresa: 143,
        nombre: "BÁSICA",
      },
      {
        idEmpresa: 143,
        nombre: "INTEGRAL",
      },
      {
        idEmpresa: 291,
        nombre: "GNP",
      },
      {
        idEmpresa: 218,
        nombre: "PLAN SEGURO",
      },
      {
        idEmpresa: 291,
        nombre: "DANONE",
      },
      {
        idEmpresa: 410,
        nombre: "SISNOVA",
      },
      {
        idEmpresa: 218,
        nombre: "TELMEX",
      },
      {
        idEmpresa: 143,
        nombre: "EMPLEADOS COLECTIVOS",
      },
      {
        idEmpresa: 377,
        nombre: "HSBC",
      },
      {
        idEmpresa: 291,
        nombre: "PYMES",
      },
      {
        idEmpresa: 470,
        nombre: "INTEGRA SALUD",
      },
      {
        idEmpresa: 407,
        nombre: "MAPFRE",
      }
    ],
    pestania: null,
    columnas: [
      {
        nombre: "Nombre",
      },
      {
        nombre: "Paterno",
      },
      {
        nombre: "Materno",
      },
      {
        nombre: "Sexo",
      },
      {
        nombre: "AgentKey",
      },
      {
        nombre: "Nombre Agente",
      },
      {
        nombre: "Territorio",
      },
      {
        nombre: "Region",
      },
      {
        nombre: "Oficina",
      },
      {
        nombre: "Tipo Canal",
      },
      {
        nombre: "Canal",
      },
      {
        nombre: "PromotionKey",
      },
      {
        nombre: "Promotor",
      },
      {
        nombre: "Estado",
      },
      {
        nombre: "Municipio",
      },
    ],
    columnaNombre: null,

    // ----
    caracteresArray: [],
    caracteresArrayCantidad: 0,
    layoutTablaCaracteresArray: [
      {
        key: "idCaracterReemplazo",
        label: "Id",
        sortable: true,
      },
      {
        key: "nombrePestania",
        label: "Nombre Pestaña",
        sortable: true,
      },
      {
        key: "encabezado",
        label: "Columna",
        sortable: true,
      },
      {
        key: "caracter",
        label: "Caracter",
        sortable: true,
      },
      {
        key: "reemplazo",
        label: "Reemplazo",
        sortable: true,
      },
      {
        key: "orden",
        label: "Orden",
        sortable: true,
      },
      {
        key: "fechaAlta",
        label: "Fecha Alta",
        sortable: true,
      },
      {
        key: "fechaModificacion",
        label: "Fecha Modificación",
        sortable: true,
      },
      {
        key: "nombreUsuarioModificacion",
        label: "Usuario Modificación",
        sortable: true,
      },
      {
        key: "orden",
        label: "Orden",
        sortable: true,
      },
      {
        key: "orden",
        label: "Orden",
        sortable: true,
      },
      {
        key: "registroActivo",
        label: "Registro Activo",
      },
      {
        key: "editar",
        label: "Editar",
      },
    ],
    form: {
      idEmpresa: null,
      nombrePestania: null,
      encabezado: null,
      caracter: null,
      reemplazo: null,
      orden: null,
      registroActivo: true,
      usuarioAlta: null,
      usuarioModificacion: null,
      canal: null
    },

    estatus: [
      {
        boolean: true,
        nombre: "ACTIVO",
      },
      {
        boolean: false,
        nombre: "INACTIVO",
      },
    ],
    modificarFormulario: false,
    // ------------------

    idArchivoCarga: null,
    nombreArchivo: null,
    // ------
    // tabla archivos cargados
    // ------
    archivosCargadosArray: [],
    layoutTablaArchivosCargados: [
      {
        key: "idArchivoCarga",
        label: "Id",
        sortable: true,
      },
      {
        key: "nombreEmpresa",
        label: "Empresa",
        sortable: true,
      },
      {
        key: "nombre",
        label: "Nombre del Archivo",
        sortable: true,
      },
      {
        key: "progreso",
        label: "Estatus del proceso",
        sortable: true,
      },
      {
        key: "fechaAlta",
        label: "Fecha Alta",
        sortable: true,
      },
      {
        key: "visualizar",
        label: "Visualizar",
        sortable: true,
      },
    ],

    registrosPorPaginaArchivosCargados: 10,
    paginaActualTablaArchivosCargados: 1,
    datosTablaRowArchivosCargados: 0,

    // ------
    // tabla datos etl temporal
    // ------

    datosEtlTemporalArray: [],
    layoutTabladatosEtlTemporal: [
      {
        key: "id",
        label: "Id",
        sortable: true,
      },
      {
        key: "idArchivoCarga",
        label: "id Archivo Carga",
        sortable: true,
      },
      {
        key: "nombrePestania",
        label: "Nombre Pestaña",
        sortable: true,
      },
      {
        key: "numeroFila",
        label: "Número Fila",
        sortable: true,
      },
      {
        key: "idPlan",
        label: "Id Plan",
        sortable: true,
      },
      {
        key: "nombrePlan",
        label: "Nombre Plan",
        sortable: true,
      },
      {
        key: "nombre",
        label: "Nombre",
        sortable: true,
      },
      {
        key: "paterno",
        label: "Paterno",
        sortable: true,
      },
      {
        key: "materno",
        label: "Materno",
        sortable: true,
      },
      {
        key: "fechaNacimiento",
        label: "Fecha Nacimiento",
        sortable: true,
      },
      {
        key: "nombreSexo",
        label: "Sexo",
        sortable: true,
      },
      {
        key: "idPaciente",
        label: "Id Paciente",
        sortable: true,
      },
      {
        key: "clavePaciente",
        label: "Clave Paciente",
        sortable: true,
      },
      {
        key: "hashseedPaciente",
        label: "Hashseed Paciente",
        sortable: true,
      },
      {
        key: "numeroPoliza",
        label: "Número Póliza",
        sortable: true,
      },
      {
        key: "inicioVigencia",
        label: "Inicio Vigencia",
        sortable: true,
      },
      {
        key: "finVigencia",
        label: "Fin Vigencia",
        sortable: true,
      },
      {
        key: "idAgente",
        label: "Id Agente",
        sortable: true,
      },
      {
        key: "claveAgente",
        label: "Clave Agente",
        sortable: true,
      },
      {
        key: "nombreAgente",
        label: "Nombre Agente",
        sortable: true,
      },
      {
        key: "idTerritorio",
        label: "Id Territorio",
        sortable: true,
      },
      {
        key: "nombreTerritorio",
        label: "Nombre Territorio",
        sortable: true,
      },
      {
        key: "idRegion",
        label: "Id Region",
        sortable: true,
      },
      {
        key: "nombreRegion",
        label: "Nombre Region",
        sortable: true,
      },
      {
        key: "idOficina",
        label: "Id Oficina",
        sortable: true,
      },
      {
        key: "nombreOficina",
        label: "Nombre Oficina",
        sortable: true,
      },
      {
        key: "idCanalTipo",
        label: "Id Canal Tipo",
        sortable: true,
      },
      {
        key: "nombreCanalTipo",
        label: "Nombre Canal Tipo",
        sortable: true,
      },
      {
        key: "idCanal",
        label: "idCanal",
        sortable: true,
      },
      {
        key: "nombreCanal",
        label: "nombreCanal",
        sortable: true,
      },
      {
        key: "idPromotorClave",
        label: "idPromotorClave",
        sortable: true,
      },
      {
        key: "promotorKey",
        label: "promotorKey",
        sortable: true,
      },
      {
        key: "idPromocion",
        label: "idPromocion",
        sortable: true,
      },
      {
        key: "nombrePromocion",
        label: "nombrePromocion",
        sortable: true,
      },
      {
        key: "idEstado",
        label: "idEstado",
        sortable: true,
      },
      {
        key: "nombreEstado",
        label: "nombreEstado",
        sortable: true,
      },
      {
        key: "idMunicipio",
        label: "idMunicipio",
        sortable: true,
      },
      {
        key: "nombreMunicipio",
        label: "nombreMunicipio",
        sortable: true,
      },
      {
        key: "fechaAlta",
        label: "fechaAlta",
        sortable: true,
      },
      {
        key: "nombreCanalTipo",
        label: "nombreCanalTipo",
        sortable: true,
      },
      {
        key: "nombreCanalTipo",
        label: "nombreCanalTipo",
        sortable: true,
      },
      {
        key: "nombreCanalTipo",
        label: "nombreCanalTipo",
        sortable: true,
      },
      {
        key: "nombreCanalTipo",
        label: "nombreCanalTipo",
        sortable: true,
      },
      //   {
      //     key: "idPersona",
      //     label: "Id Persona",
      //     sortable: true,

      //   },
    ],
    registrosPorPaginaEtlTemporal: 100,
    paginaActualTablaEtlTemporal: 1,
    datosTablaRowEtlTemporal: 0,

    // ------
    //
    // ------
    busquedaPorNombre: false,
    nombre: null,

    datosEtlTemporalArrayNombre: [],
    datosEtlTemporalArrayOriginalNombre: [],
    registrosPorPaginaEtlTemporalNombre: 100,
    paginaActualTablaEtlTemporalNombre: 1,
    datosTablaRowEtlTemporalNombre: 0,

    // ------
    //
    // ------
    nombreFinal: null,
    datosEtlFinalArrayNombre: [],
    datosTablaRowEtlFinalNombre: 0,
    paginaActualTablaEtlFinalNombre: 1,
    // ------
    //
    // ------
    permitirDescargaExcelErrores: false,
    datosErroresArrayJson: [],
    layoutExcelErrores: {
      "Nombre Pestaña": "nombrePestania",
      "Numero Fila": "numeroFila",
      Error: "error",
    },

    // ------
    //
    // ------

    // ------
    //
    // ------
    listaCanales:[],
    canal: null 

  }),

  mounted() {},
  methods: {
    buscarCaracteres() {
      this.loading = true;
      this.caracteresArray = null;
      let data = {
        'idEmpresa': this.idEmpresa,
        'columna': this.columnaNombre,
        'pestania': this.pestania,
        'canal':   this.canal
      }
      this.$http
        .post(
          this.$api +
            "etl/caracteres/empresa/columna", data
        )
        .then((response) => {
          //NO devuelve un array asi que no funciona validar isArray
          this.caracteresArray = response.data.data;
          this.caracteresArrayCantidad = this.caracteresArray.length;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        })
        .finally((this.loading = false));
    },

    guardarCaracter() {
      this.loading = true;
      if (this.validacionCabeceras()) {
        this.$swal({
          icon: "warning",
          text: "Favor de capturar todos los datos.",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
      } else {
        if (this.form.registroActivo == null) {
          this.form.registroActivo = false;
        }
        this.form.usuarioModificacion =
          this.$localStorageService.getIdUsuario();

        if (this.modificarFormulario) {
          this.$http
            .put(this.$api + "etl/caracter", this.form)
            .then((response) => {
              //NO devuelve un array asi que no funciona validar isArray
              if (response.data.data == true) {
                this.$swal({
                  icon: "success",
                  text: "Exito al guardar el registro",
                  confirmButtonText: "OK",
                  confirmButtonColor: "#0e6ba9",
                });
                this.modificarFormulario = false;
              } else {
                this.$swal({
                  icon: "error",
                  text: "A ocurrido un error, intentalo más tarde.",
                  confirmButtonText: "OK",
                  confirmButtonColor: "#0e6ba9",
                });
              }
            })
            .catch((error) => {
              console.error(error);
              this.$swal({
                icon: "error",
                text: "No se pudo guardar, verifique datos ingresados",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
              });
            })
           .finally(()=>{
            this.loading = false;
            this.canal = this.form.canal
            this.columnaNombre = this.form.encabezado;
            if(this.canal === 27){
              this.idEmpresa = this.form.idEmpresa;
            }else{
              this.idEmpresa = 0;
            }
            this.buscarCaracteres()
            });
        } else {
          
        this.form.usuarioAlta =
          this.$localStorageService.getIdUsuario();
          
          
          this.$http
            .post(this.$api + "etl/caracter", this.form)
            .then((response) => {
              //NO devuelve un array asi que no funciona validar isArray
              if (response.data.data == true) {
                this.$swal({
                  icon: "success",
                  text: "Exito al guardar el registro",
                  confirmButtonText: "OK",
                  confirmButtonColor: "#0e6ba9",
                });
              } else {
                this.$swal({
                  icon: "error",
                  text: "A ocurrido un error, intentalo más tarde.",
                  confirmButtonText: "OK",
                  confirmButtonColor: "#0e6ba9",
                });
              }
            })
            .catch((error) => {
              console.error(error);
              this.$swal({
                icon: "error",
                text: "No se pudo guardar, verifique datos ingresados",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
              });
            })
            .finally(()=>{
            this.loading = false
            this.canal = this.form.canal
            this.columnaNombre = this.form.encabezado;
            if(this.canal === 27){
              this.idEmpresa = this.form.idEmpresa;
            }else{
              this.idEmpresa = 0;
            }
            this.buscarCaracteres()
            });
        }
      }

      this.loading = false;
    },
    validacionCabeceras() {
      if (this.form.canal === 27) {
        if (this.form.idEmpresa === null ||
            this.form.idEmpresa === "" ||
            this.form.nombrePestania === null ||
            this.form.nombrePestania === "" ||
            this.form.encabezado === null ||
            this.form.encabezado === "" ||
            this.form.caracter === null ||
            this.form.caracter === "" ||
            this.form.orden === null ||
            this.form.orden === "" ||
            this.form.canal === null) {
          return true
        } else {
          return false;
        }
      } else if (this.form.canal === 28) {
        if (this.form.encabezado === null ||
            this.form.encabezado === "" ||
            this.form.caracter === null ||
            this.form.caracter === "" ||
            this.form.orden === null ||
            this.form.orden === "" ||
            this.form.canal === null) {
          return true
        } else {
          return false;
        }
      } else {
        if (this.form.encabezado == null ||
            this.form.encabezado == "" ||
            this.form.caracter == null ||
            this.form.caracter == "" ||
            this.form.orden == null ||
            this.form.orden == "" ||
            this.form.canal == null) {
          return true
        } else {
          return false;
        }
      }
    },
    modificar(idCaracterReemplazo) {
      this.modificarFormulario = true;
      let registro = this.caracteresArray.filter(
        (car) => car.idCaracterReemplazo == idCaracterReemplazo
      );
      this.form = registro[0];
    },
    cambiarAGuardar() {
      this.form = {
        idEmpresa: null,
        nombrePestania: null,
        encabezado: null,
        caracter: null,
        reemplazo: null,
        orden: null,
        registroActivo: true,
        usuarioAlta: null,
        usuarioModificacion: null,
        canal:null
      };
      this.modificarFormulario = false;
    },
  obtenerSistemasCaracteres() {
      this.loading = true;

      this.caracteresArray = null;
      this.$http
        .get(this.$api +"catalogos/remplazaracaracteres/canalorigen")
        .then((response) => {
          //NO devuelve un array asi que no funciona validar isArray
          this.listaCanales = response.data.data;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        })
        .finally((this.loading = false));
    },
    obtenerSistemaSeleccionado(){
      if(this.canal === 28){
         this.idEmpresa = 0;
         this.pestania = null;
         this.columnaNombre = null
      }
      if(this.form.canal === 28){
          this.form.idEmpresa = null;
          this.form.nombrePestania = null;
      }
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.idEmpleado = this.$localStorageService.getIdEmpleado();
    this.idClinica = this.$localStorageService.getIdClinica();
    this.idUsuario = this.$localStorageService.getIdUsuario();
    this.obtenerSistemasCaracteres();
  },
  computed: {},
  watch: {},
};
</script>
<style scoped>
 .disabled {
      pointer-events:none;
      color: #bfcbd9;
      cursor: not-allowed;
      background-image: none;
      background-color: #eef1f6;
      border-color: #d1dbe5;   
    }
</style>
